<template>
  <div id="lcly-button-0" data-switchlive="true" data-switchlive-impression="true" data-switchlive-impression-id-PL="1">
    <a id="lcly-link-0" data-switchlive="true" data-switchlive-mode="auto" data-switchlive-id-PL="6"
      role="button" href="https://join.locally.com/for-brands" target="_blank">
      Product Locator by Locally
    </a>
  </div>
</template>
<script>
export default {
  name: "locally-product",
  props: {
    stock_code: {
      type: String
    },
    netsuite_id: {
      type: String
    },
    price: {
      type: Number,
    },
    components: {
      type: Array
    },
    category: {
      type: Object
    },
    item_brand: {
      type: String,
      default: "Rhinorack"
    },
  },
  data() {
    return {
      currency: window.currency,
      culture: window.culture,
      country: window.country,
      product_category: '',
    }
  },
  mounted() {
    // Create the first script element
    var scriptElement0 = document.createElement("script");
    scriptElement0.id = "lcly-script-0";
    scriptElement0.async = true;
    // Create the second script element
    var scriptElement1 = document.createElement("script");
    scriptElement1.id = "lcly-config-0";
    // Set the inner HTML of the second script element
    if (!this.components.length) {
      scriptElement1.innerHTML = `
      var __lcly_channel_domain_0 = "locally";
      var lcly_config_0 = {"company_name": "Rhino Rack","button_id": "HTML","company_id": "22280","css": "4","always_hide_button": "1","style": "` + this.stock_code + `","show_location_switcher": "1","show_location_prompt": "1","lang": "en-us","show_dealers": "1","n_dealers": "3", "link_opens_modal": "1"};
      var lcly_query_0 = Object.keys(lcly_config_0)
      .reduce(function(a,k){a.push(encodeURIComponent(k) + '=' + encodeURIComponent(lcly_config_0[k]));return a},[]).join('&');
      var lcly_endpoint_0 = 'https://rhino-rack.locally.com/stores/map.js?' + lcly_query_0;
      document.getElementById('lcly-script-0').src = lcly_endpoint_0;
      `;
    } else {
      let kit = { must_have: [] };

      this.components.forEach(element => {
        var upc = element.product.upccode;
        var qty = element.qty;
        kit.must_have.push({ upc: upc, qty: qty });
      });

      scriptElement1.innerHTML = `
      var __lcly_channel_domain_0 = "locally";
        var lcly_config_0 = {"company_name": "Rhino Rack", "button_id": "HTML", "company_id": "22280","css": "4","always_hide_button": "1","show_location_switcher": "1","show_location_prompt": "1","lang": "en-us", "show_dealers": "1","n_dealers": "3","show_only_upc_stocking_dealers": "1","void_dealer_click": "1","no_link": "1","kit": ${JSON.stringify(kit)}, };
        var lcly_query_0 = Object.keys(lcly_config_0)
        .reduce(function(a, k) {a.push(encodeURIComponent(k) + '=' 
        + encodeURIComponent((typeof lcly_config_0[k] === 'object' && lcly_config_0[k] !== null)? JSON.stringify(lcly_config_0[k])  : lcly_config_0[k]));return a;}, []).join('&');
        var lcly_endpoint_0 = 'https://rhino-rack.locally.com/stores/map.js?' + lcly_query_0;
        document.getElementById('lcly-script-0').src = lcly_endpoint_0;
        `;

    }
    console.log(scriptElement1.innerHTML);
    // Append the script elements to the document body
    document.body.appendChild(scriptElement0);
    document.body.appendChild(scriptElement1);

    var scriptElement2 = document.createElement("script");
    scriptElement2.id = "lcly-script-switchlive-0";
    scriptElement2.async = true;
    scriptElement2.src = 'https://rhino-rack.locally.com/js/switchlive.js?company_id=22280';
    var scriptElement3 = document.createElement("script");
    scriptElement3.id = "lcly-script-switchlive-events-0";
    scriptElement3.async = true;
    scriptElement3.src = 'https://rhino-rack.locally.com/switchlive/switchlive-events.js?company_id=22280';
    document.body.appendChild(scriptElement2);
    document.body.appendChild(scriptElement3);

    window.switchLiveEventCallback = this.switchLiveEventCallback;
  },
  methods: {
    switchLiveEventCallback(switchLiveEvent) {
      console.log(switchLiveEvent);
      this.product_category = this.category?.title || "";

      const item_id = this.components && this.components.length === 0 ? this.stock_code : '';

      if (item_id !== '') {
        var ga_tracking_category = {
          '1': 'locally_pl_pdp_widget_loaded',
          '4': 'locally_pl_pdp_store_link_clicked',
          '5': 'locally_pl_pdp_location_change',
          '6': 'locally_pl_pdp_show_all_local_options',
          '7': 'locally_pl_modal_product_locator_modal_loaded',
          '9': 'locally_pl_modal_store_link_clicked',
          '46': 'locally_pl_modal_product_overview',
          '82': 'locally_pl_modal_add_to_cart',
          '83': 'locally_pl_modal_order_placed',
          '86': 'locally_pl_modal_buy_now',
          '56': 'locally_sl_inline_store_loaded',
          '59': 'locally_sl_browse_stock',
          '61': 'locally_sl_product_loaded',
          '63': 'locally_sl_browse_inventory',
          '66': 'locally_sl_product_detail',
          '68': 'locally_sl_buy_now',
          '71': 'locally_sl_click_ropis',
          '73': 'locally_sl_call_store',
          '75': 'locally_sl_store_loaded',
          '77': 'locally_sl_view_store',
          '80': 'locally_sl_add_to_cart',
          '84': 'locally_sl_purchase',
        }[switchLiveEvent.id] || '';

        if (ga_tracking_category !== '') {
          gtag('event', ga_tracking_category, {
                "item_id": item_id,
                "item_name": item_id,
                "id": switchLiveEvent.id,
                "scope": switchLiveEvent.scope,
                "type": switchLiveEvent.type,
                "description": switchLiveEvent.description,
                "timestamp": switchLiveEvent.timestamp,
                "url": switchLiveEvent.url,
                "locale_code": switchLiveEvent.locale_code,
                "product_id": switchLiveEvent.product_id,
                "style": switchLiveEvent.style,
                "upc": switchLiveEvent.upc,
                "store_id": switchLiveEvent.store_id,
                "store_address": switchLiveEvent.store_address,
                "store_name": switchLiveEvent.store_name,
                "vendor_id": switchLiveEvent.vendor_id,
                "store_stock_status": switchLiveEvent.store_stock_status,
                "store_stock_count": switchLiveEvent.store_stock_count,
                "company_id": switchLiveEvent.company_id,
                "sale_type": switchLiveEvent.sale_type || '',
                "item_brand": this.item_brand,
                "item_category": this.product_category,
                "product_price": switchLiveEvent.product_price || ''
          });
        }
      }
    },
  }
}
</script>